import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import ProductsPage from './pages/ProductsPage';
import ProductDetailPage from './pages/ProductDetailPage';
import AboutPage from './pages/AboutPage';

const PlaceholderPage = ({ title }) => (
  <div className="min-h-[60vh] flex items-center justify-center bg-gray-50">
    <div className="text-center">
      <h1 className="text-3xl font-bold text-gray-900 mb-4">{title}</h1>
      <p className="text-gray-600 mb-6">Coming soon.</p>
      <a href="/#/products" className="text-brand-600 hover:underline">Return to Products</a>
    </div>
  </div>
);

const App = () => {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          {/* Default to Products as home for now, or could be a dedicated landing */}
          <Route index element={<Navigate to="/products" replace />} />
          
          <Route path="products" element={<ProductsPage />} />
          <Route path="products/:id" element={<ProductDetailPage />} />
          
          <Route path="about" element={<AboutPage />} />
          
          {/* Catch all */}
          <Route path="*" element={<Navigate to="/products" replace />} />
        </Route>
      </Routes>
    </HashRouter>
  );
};

export default App;

